import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';

import CircularProgress from '@material-ui/core/CircularProgress';
import AgGrid from '@components/AgGrid/AgGrid';
import { LinkCellRenderer } from '@trueprodigy/components';

import RevisionHistoryLog from './EventRevisionHistoryLog';
import * as eventActions from '@modules/events/actions/event';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { convertObjectToString } from '@utils';

const EventRevisionHistory = ({ eventID }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const res = await dispatch(
        eventActions.fetchEventRevisionHistory({
          eventID,
        }),
      );
      if (res && res.results) {
        setData(res.results);
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const getColumnDefs = () => {
    const columnDefs = [
      {
        headerName: 'Id',
        field: 'revisionHistoryID',
        maxWidth: 90,
        width: 90,
        cellRenderer: LinkCellRenderer,
        cellRendererParams: {
          onClick: revisionHistoryID => setSelectedId(revisionHistoryID),
        },
      },
      {
        headerName: 'Date Time',
        field: 'changeDt',
        maxWidth: 190,
        width: 190,
        cellRenderer: ({ value }) => moment(value).format('MMM D, YYYY h:mm A'),
      },
      {
        headerName: 'User',
        field: 'changeBy',
        maxWidth: 210,
        width: 210,
      },
      {
        headerName: 'Table',
        field: 'tableName',
        maxWidth: 150,
        width: 150,
      },
      {
        headerName: 'Action',
        field: 'userAction',
        maxWidth: 130,
        width: 130,
      },
      {
        headerName: 'Metadata',
        field: 'metaData',
        cellRenderer: ({ value }) => convertObjectToString(value),
      },
    ];
    return columnDefs;
  };
  return (
    <div>
      <h3 style={{ padding: 10, fontWeight: 'bold' }}>Revision History</h3>
      {selectedId ? (
        <>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            style={{ marginLeft: 20 }}
          >
            <Link
              to="#"
              style={{ textDecoration: 'underline' }}
              onClick={() => setSelectedId(null)}
            >
              Revision History
            </Link>
            <Typography color="textPrimary">{selectedId}</Typography>
          </Breadcrumbs>
          <RevisionHistoryLog
            revisionHistoryList={data}
            selectedId={selectedId}
            onClose={() => setSelectedId(null)}
          />
        </>
      ) : (
        <div>
          {isLoading ? (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress />
            </div>
          ) : (
            <div className="ag-theme-material">
              <AgGridWrapper>
                <AgGrid
                  defaultColDef={{ resizable: true, sortable: true }}
                  columnDefs={getColumnDefs()}
                  name="eventRevisionHistory"
                  disablePreferenceSave
                  rowData={data}
                />
              </AgGridWrapper>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

EventRevisionHistory.propTypes = {
  eventID: PropTypes.any,
};

const AgGridWrapper = styled.div`
  height: calc(100vh - 390px);
`;

export default EventRevisionHistory;
